import React, { FC, useCallback, useEffect, useState } from 'react';

import {
	EvTitle,
	HeadingLevelRange,
	ScreenshotDetails,
	TITLE_MODES
} from '@evinced-private/ui-common';

import { SCREENSHOT_BLOCK_DAID } from 'data-automation-ids/data-automation-ids';
import { Logger } from 'src/common/services/Logger';
import { screenshotService } from 'src/common/services/ScreenshotService';

import './ScreenshotBlock.scss';

interface IScreenshotBlockProps {
	screenshotDetails: ScreenshotDetails;
	subheadingsLevel: HeadingLevelRange;
}

export const ScreenshotBlock: FC<IScreenshotBlockProps> = ({
	screenshotDetails,
	subheadingsLevel
}) => {
	const [image, setImage] = useState<string>(null);
	const resolveImage = useCallback(
		async (screenshotDescriptor: ScreenshotDetails): Promise<void> => {
			try {
				const screenshotImageData =
					await screenshotService.getFullPageScreenshotWithIssues(screenshotDescriptor);
				setImage(screenshotImageData);
			} catch (e) {
				Logger.warn('Screenshot could not be loaded', e);
				setImage(null);
			}
		},
		[]
	);

	useEffect(() => {
		if (!image && screenshotDetails) {
			resolveImage(screenshotDetails);
		}
	}, [screenshotDetails, image, resolveImage]);

	return (
		image && (
			<div className="screenshot-block" data-automation-id={SCREENSHOT_BLOCK_DAID}>
				<EvTitle
					titleText="Screenshot"
					mode={TITLE_MODES.NORMAL}
					className="subheading"
					headingLevel={subheadingsLevel}
				/>
				<div className="screenshot-picture">
					<img className="screenshot-img" src={image} alt="Issue Screenshot" />
				</div>
			</div>
		)
	);
};
